import JwtStoreActions from "../flux/JwtStoreActions";
import { useEffect, useState } from "react";
import PageLoadingOverlay from "../components/PageLoadingOverlay";
import JwtStore from "../flux/JwtStore";
import postMessageToParent from "../utils/postMessageToParent";

export default function Logout() {
  useEffect(function() {
    // const didAuthenticateViaOidc = JwtStore.authenticationMethod('oidc');

    JwtStoreActions.logout();

    window.localStorage.removeItem('enrolled-in-biometric-auth');

    postMessageToParent('unset-named-user');

    requestAnimationFrame(function() {
      // if (didAuthenticateViaOidc) {
      // We do not care if OIDC or not, we always go through the CMS to clean cookies
      // to simplify (by unifying) the logout flow.
      const result = postMessageToParent('init-logout-flow', {
        logoutEndpoint: `${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/oauth2/logout-callback`,
      });

      if (result === false) {
        window.location.href = `${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/oauth2/logout-callback?redirect_uri=${window.location.origin}`;
      }
      // } else {
      //   window.location.href = `${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/logout?redirect_uri=${window.location.origin}`;
      // }
    });
  }, []);

  return (
    <PageLoadingOverlay visible />
  );
}
